import apis, { StatusModel } from "@/apis";
import axios from "axios";
import { ref } from "vue";

export interface UserStatusModel extends StatusModel { isInited: boolean }

class UserStatus {
  private static instance_: UserStatus;
  private static status_ = ref({
    isInited: false,
  } as UserStatusModel);
  private constructor() {}

  private static apiGetStatus = () => {
    return axios({
      url: apis.status.url,
      method: apis.status.method,
    });
  }

  public static updateUserStatus = async (doForce = false): Promise<void> => {
    if (!doForce && UserStatus.status_.value.isInited) return;
    const d = (await UserStatus.apiGetStatus()).data as StatusModel;
    UserStatus.status_.value.role = d.role;
    UserStatus.status_.value.identity = d.identity;
    UserStatus.status_.value.ip = d.ip;
    if (!UserStatus.status_.value.isInited) UserStatus.status_.value.isInited = true;
  }

  public static get instance(): UserStatus {
    return this.instance_ || (this.instance_ = new this());
  }

  public static get status(): UserStatusModel {
    return UserStatus.status_.value;
  }
}

export default UserStatus;

